import { createAction, props } from '@ngrx/store';
import { CreateUserDto, UpdateUserDto, UserDto } from '@shared/dto';
import { PaginatedListQuery } from '@shared/interfaces/paginated-list-query.interface';

export const USERS_ACTIONS_TYPE = '@app/users';

// Read list
export const readUsers = createAction(`${USERS_ACTIONS_TYPE}/read`, (query?: PaginatedListQuery) => ({ query }));
export const readUsersSuccess = createAction(`${USERS_ACTIONS_TYPE}/read/success`, props<{ data: UserDto[]; total: number }>());
export const readUsersFailure = createAction(`${USERS_ACTIONS_TYPE}/read/failure`, props<{ error: any }>());

// Read single (detail) — resolves from the loaded list by id, falling back to a
// server fetch (readOne) so a reload/deep-link always has the full, fresh detail.
export const readUser = createAction(`${USERS_ACTIONS_TYPE}/read-one`, props<{ userId: number }>());
export const readUserSuccess = createAction(`${USERS_ACTIONS_TYPE}/read-one/success`, props<{ user: UserDto }>());
export const readUserFailure = createAction(`${USERS_ACTIONS_TYPE}/read-one/failure`, props<{ error: any }>());

// Create
export const createUser = createAction(`${USERS_ACTIONS_TYPE}/create`, props<{ dto: CreateUserDto }>());
export const createUserSuccess = createAction(`${USERS_ACTIONS_TYPE}/create/success`, props<{ user: UserDto }>());
export const createUserFailure = createAction(`${USERS_ACTIONS_TYPE}/create/failure`, props<{ error: any }>());

// Update
export const updateUser = createAction(`${USERS_ACTIONS_TYPE}/update`, props<{ userId: number; dto: UpdateUserDto }>());
export const updateUserSuccess = createAction(`${USERS_ACTIONS_TYPE}/update/success`, props<{ user: Partial<UserDto> }>());
export const updateUserFailure = createAction(`${USERS_ACTIONS_TYPE}/update/failure`, props<{ error: any }>());

// Delete
export const deleteUser = createAction(`${USERS_ACTIONS_TYPE}/delete`, props<{ userId: number }>());
export const deleteUserSuccess = createAction(`${USERS_ACTIONS_TYPE}/delete/success`, props<{ user: UserDto }>());
export const deleteUserFailure = createAction(`${USERS_ACTIONS_TYPE}/delete/failure`, props<{ error: any }>());

// Restore
export const restoreUser = createAction(`${USERS_ACTIONS_TYPE}/restore`, props<{ userId: number }>());
export const restoreUserSuccess = createAction(`${USERS_ACTIONS_TYPE}/restore/success`, props<{ user: UserDto }>());
export const restoreUserFailure = createAction(`${USERS_ACTIONS_TYPE}/restore/failure`, props<{ error: any }>());
